import { render } from "./WarehouseList.vue?vue&type=template&id=4c751b59"
import script from "./WarehouseList.vue?vue&type=script&lang=ts"
export * from "./WarehouseList.vue?vue&type=script&lang=ts"
script.render = render

export default script